import { useCallback, useMemo } from 'react';

import fuzzySearch from './fuzzySearch';
import type { FuzzyReturnType, FuzzySearchOptions } from './types';

function useFuzzy<TElement = unknown>(
    items: TElement[],
    options?: Partial<FuzzySearchOptions>,
): FuzzyReturnType<TElement[]> {
    const searchMethod = useMemo(() => fuzzySearch(items, options), [items, options]);
    const search = useCallback((searchString: string) => searchMethod(searchString), [searchMethod]);
    return { search };
}

export default useFuzzy;
